<template>
  <div>
    <loader :working="working"></loader>
    
    <post v-for="(post, index) in posts" :key="post.id" :post="post" :index="index"></post>

    <div class="text-center mt-3" v-if="!working && pager.more && pager.enabled">
      <button class="btn btn-outline-primary" @click="load()">
        <span class="spinner-border spinner-border-sm mr-1" v-if="pager.working"></span>
        Mehr laden
      </button>
    </div>

    <div class="text-center" v-if="!working && !posts.length">
      Es tut uns leid, aber wir konnten leider keine Stories finden.
    </div>
  </div>
</template>

<script>
  import Loader from '@/vues/helpers/loader.vue';
  import Post from './post.vue';

  export default {
    name: 'Story-List',
    components: { Loader, Post },
    props: {
      resource: String,
      params: {
        type: Object,
        default: () => {
          return {};
        }
      },
      perPage: {
        type: Number,
        default: 20
      },
      offset: {
        type: Number,
        default: 0
      },
      enablePager: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        working: true,
        pager: {
          enable: true,
          working: false,
          more: false,
          offset: null,
          perPage: null
        },
        posts: []
      };
    },
    async mounted () {
      this.pager.perPage = this.perPage;
      this.pager.offset  = this.offset;
      this.pager.enabled = this.enablePager;

      await this.load();
    },
    watch: {
      async params () {
        await this.reset();
      },
      async resource () {
        await this.reset();
      }
    },
    methods: {
      async reset () {
        this.pager.offset = 0;
        this.posts = [];

        await this.load();
      },
      async load () {
        this.working = true;

        this.params.offset = this.pager.offset;
        this.params.limit  = this.pager.perPage;
        this.params.imgOptions = JSON.stringify({
          width: 100,
          height: 70,
        });

        const res = await this.$http.get(this.resource, { params: this.params });
        if (this.posts.length) {
          this.posts = this.posts.concat(res.body);
        } else {
          this.posts = res.body;
        }

        this.pager.more = res.body.length > 0 && res.body.length === this.pager.perPage;
        
        this.working = this.pager.working = false;
        this.pager.offset += this.pager.perPage;
      }
    }
  };
</script>
